import React from 'react';
import GameList from "./GameList";

import './Home.css';
import {GAMES} from "./constants";
import { Epic, PanelHeader, SplitCol, SplitLayout, Tabbar, TabbarItem } from "@vkontakte/vkui";


class Home extends React.Component {
  ITEMS = [
    {slug: 'puzzle', title: 'Пазл', icon: 'play'},
    {slug: 'quiz', title: 'Викторина', icon: 'signs'},
    {slug: 'city', title: 'Города', icon: 'furniture-and-household'},
    {slug: 'nature', title: 'Природа', icon: 'maps-and-flags'}
  ];
    // {slug: 'space', title: 'Космос', icon: 'maps-and-flags'}];

  componentDidMount() {
    if (this.props.records === null) {
      let keys = this.ITEMS.map(item =>
        GAMES[item.slug].sections.reduce((acc, section) =>
          [...acc, section.items.map(game => `${item.slug}-${game.slug}`)], []));
      let games = keys.reduce((acc, curr) => acc.concat(curr.reduce((a2, c2) => a2.concat(c2), []) ),[]);
      this.props.onLoadRecords(games);
    }
  }

  render() {
    return <SplitLayout header={<PanelHeader/>}>
      <SplitCol>
        <Epic activeStory={this.props.activeStory} tabbar={
          <Tabbar>
            {this.ITEMS.map(item =>
              <TabbarItem onClick={this.props.onStoryChange} selected={this.props.activeStory === item.slug} data-story={item.slug} text={item.title} key={item.slug}>
                <img src={`https://d2nepmml5nn7q0.cloudfront.net/vkminiapp/icons/${item.icon}.png`} />
              </TabbarItem>)}
          </Tabbar>
        }>
          {this.ITEMS.map(item => <GameList id={item.slug} setGame={this.props.setGame} key={item.slug} records={this.props.records}/>)}
        </Epic>
      </SplitCol>
    </SplitLayout>;
  }
}

export default Home;
